<template>
  <div class="relative w-full h-screen-minus-80 flex items-center justify-left overflow-x-auto">
    <div class="w-[360px] h-full relative">
      <div class="flex border flex-col items-left h-screen-minus-80 bg-white ">
        <div class="Roboto-Bold-20 pt-4 px-6" @click="pickColorShow = false">
          {{ $t('id_photo_maker') }}
        </div>
        <div class="mt-3" @click="pickColorShow = false">
          <span class="Roboto-Bold-14 pl-6">
            {{ $t('Size') }}
          </span>
          <div class="px-6">
            <div @click="onSize(index)"
              class="w-full h-12 rounded-2xl bg-light-gray-bg flex items-center my-2 cursor-pointer hover:bg-[#5F45FF14]"
              v-for="(item, index) in list" :key="item" :value="item"
              :class="{ 'border-2 border-[#5F45FF]': index == selectSize, ' border border-gray-line': index != selectSize }">
              <div class="pl-4">
                <div class="absolute" :class="{ 'opacity-0': index != selectSize }">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 12.15L10.5484 16L17 9" stroke="url(#paint0_linear_3753_35793)" stroke-width="3"
                      stroke-linecap="round" />
                    <defs>
                      <linearGradient id="paint0_linear_3753_35793" x1="7" y1="12.5" x2="17" y2="12.5"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#4A2DFF" />
                        <stop offset="1" stop-color="#C02CFF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11.5" fill="white" stroke="#E9E9EB" />
                  </svg>
                </div>
              </div>

              <div class="flex justify-between items-center w-full px-3">
                <div class="Roboto-Bold-14">
                  {{ item.content }}
                </div>
                <div v-if="index == 1" class="flex justify-end">
                  <a-input-number
                    :style="{ width: '75px', backgroundColor: 'white', color: 'gray', paddingRight: '2px', paddingLeft: '10px', borderRadius: '10px', borderColor: 'white' }"
                    placeholder="" :hide-button="true" v-model="num1" :max="2000" :min="100" :precision="0">
                    <template #prefix>
                      <span class="text-text-gray">
                        W
                      </span>
                    </template>
                  </a-input-number>
                  <a-input-number
                    :style="{ width: '75px', backgroundColor: 'white', color: 'gray', marginLeft: '10px', paddingRight: '2px', paddingLeft: '10px', borderRadius: '10px', borderColor: 'white' }"
                    placeholder="" :hide-button="true" v-model="num2" :max="2000" :min="100" :precision="0">
                    <template #prefix>
                      <span class="text-text-gray">
                        H
                      </span>
                    </template>
                  </a-input-number>
                </div>
                <div v-else class="pr-2 text-text-gray text-sm">
                  {{ item.params }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <span class="Roboto-Bold-14 px-6">
            {{ $t('Color') }}
          </span>
          <div class="mt-2 h-full flex pl-6 gap-x-4 items-center">
            <div @click="onShowColor('white')"
              class="rounded-full w-[36px] h-[36px] flex items-center justify-center hover:bg-[#5F45FF14]"
              :class="{ 'border-2 rounded-full border-mainColor-deep': indexColor == 'white', 'cursor-not-allowed': !step1Data?.enhanceUrl, 'cursor-pointer': step1Data?.enhanceUrl }">
              <img class="w-[36px] h-[36px]" src="/assets/images/functype/IDMaker/white.svg" alt="white">
            </div>
            <div @click="onShowColor('blue')"
              class="rounded-full w-[36px] h-[36px] flex items-center justify-center hover:bg-[#5F45FF14]"
              :class="{ 'border-2 rounded-full border-mainColor-deep': indexColor == 'blue', 'cursor-not-allowed': !step1Data?.enhanceUrl, 'cursor-pointer': step1Data?.enhanceUrl }">
              <img class="w-[36px] h-[36px]" src="/assets/images/functype/IDMaker/blue.svg" alt="blue">
            </div>
            <div @click="onShowColor('red')"
              class="rounded-full w-[36px] h-[36px] flex items-center justify-center hover:bg-[#5F45FF14]"
              :class="{ 'border-2 rounded-full border-mainColor-deep': indexColor == 'red', 'cursor-not-allowed': !step1Data?.enhanceUrl, 'cursor-pointer': step1Data?.enhanceUrl }">
              <img class="w-[36px] h-[36px]" src="/assets/images/functype/IDMaker/red.svg" alt="red">
            </div>
            <div class="border-l h-[30px] border-gray-line mx-2"></div>
            <div @click="onShowColor('all')" v-if="!urlColors"
              class="rounded-full w-[36px] h-[36px] flex items-center justify-center hover:bg-[#5F45FF14]"
              :class="{ 'border-2 rounded-full border-mainColor-deep': indexColor == 'all', 'cursor-not-allowed': !step1Data?.enhanceUrl, 'cursor-pointer': step1Data?.enhanceUrl }">
              <img class="w-[28px] h-[28px]" src="/assets/images/functype/IDMaker/allcolor.svg" alt="allcolor">
            </div>
            <div @click="onShowColor('all')" v-else
              class="rounded-full w-[36px] h-[36px] flex items-center justify-center hover:bg-[#5F45FF14] p-1"
              :class="{ 'border-2 rounded-full border-mainColor-deep': indexColor == 'all', 'cursor-not-allowed': !step1Data?.enhanceUrl, 'cursor-pointer': step1Data?.enhanceUrl }">
              <div class="w-full h-full rounded-full" :style="{ backgroundColor: urlColors }"></div>
            </div>
          </div>
        </div>
        <div style="background-color: rgba(255 255 255 / 94%)"
          class="h-[88px] w-[339px] p-5 bottom-0 left-0 fixed flex justify-center">
          <EnhanceGenerate class="w-fit" @click="onApply"
            :enable="applyEnabled && !imgGeneratorList[indexImages]?.enhanceUrl" :picNum="1">
          </EnhanceGenerate>
        </div>
      </div>
    </div>
    <div class="relative h-full flex-1 flex items-center justify-center overflow-hidden" @click="pickColorShow = false">
      <div class="relative h-[700px] w-[900px] flex items-center justify-center">
        <template v-if="step == StepStatus.none">
          <EnhancePreLoad v-if="
            step1Data &&
            (step1Data.status == uploadStatus.handle ||
              step1Data.status == uploadStatus.lodingImg)
          " :fileModel="step1Data" @load="onLoad"></EnhancePreLoad>
          <FuncTypeUpload v-else class="h-[240px] mx-auto z-[2] hidden sm:block lg:h-[280px]"></FuncTypeUpload>
        </template>
        <template v-else-if="step === StepStatus.edit">
          <EnhanceImageBgColorEdit ref="imageBgEditRef" v-if="step1Data.enhanceUrl" :url="step1Data.enhanceUrl"
            :bgImgUrl="colorImg" @load="onBgLoad"></EnhanceImageBgColorEdit>
          <div v-if="fileModel && fileModel.status == uploadStatus.handle"
            class="w-[100vw] h-[100vh] fixed left-0 top-0 flex items-center justify-center flex-col bg-[#00000088]">
            <Loading />
            <p class="mt-10 text-white max-w-[50%] text-center text-xs" v-html="$t('enhance-process')"></p>
          </div>
          <div v-show="false">
            <canvas id="myCanvas"></canvas>
          </div>
        </template>
        <template v-else-if="step === StepStatus.success">
          <EnhancePreLoad v-if="fileModel.status == uploadStatus.handle" :fileModel="fileModel"></EnhancePreLoad>
          <EnhancePreLoad v-else-if="
            imgGeneratorList[indexImages].status == uploadStatus.lodingImg
          " :fileModel="imgGeneratorList[indexImages]"></EnhancePreLoad>
          <div v-else-if="
            imgGeneratorList[indexImages].status == uploadStatus.success
          " class="w-full h-full shadow-1 rounded-xl -translate-y-14">
            <EnhanceImageView ref="imageViewRef" :minScale="minScale" :maxScale="maxScale"
              :url="imgGeneratorList[indexImages].enhanceUrl"></EnhanceImageView>
            <EnhanceGiveALike class="absolute right-4 bottom-4" v-if="isLogin" v-show="imgGeneratorList[indexImages].enhanceUrl &&
              !fileModel.isEvaluate" :id="fileModel.enhanceRecordId" @onEvaluate="onEvaluate">
            </EnhanceGiveALike>
          </div>
        </template>
      </div>
    </div>
    <EnhanceColorPicker @confirm="confirm" @cancel="cancel" v-if="pickColorShow" :initialColor="urlColors"
      class="absolute bottom-[50px] left-[212px] z-[2]">
    </EnhanceColorPicker>
  </div>
</template>
<script setup>
import { uploadStatus } from "@/utils/type";
import { useMainStore } from "@/store/index";
import { useUploadStore } from "@/store/upload";
const { isLogin, isVip, isVipPro } = useUserInfo();
const { $encryptor } = useNuxtApp();
const uploadStore = useUploadStore();
const mainStore = useMainStore();
const {
  customEventNames,
  cleanMenuDownload,
  applyEvent,
  updateFileListEvent,
} = useCustomEvent();
const props = defineProps({
  fileList: {
    type: Array,
    default: [],
  },
  applyEnabled: {
    type: Boolean,
    default: false,
  }
});
const StepStatus = {
  none: 0,
  edit: 1,
  success: 2,
};
const imgGeneratorList = ref([]);
const imageViewRef = ref(null);
const { t } = useI18n();
const pickColorShow = ref(false);
const step = ref(StepStatus.none);
const step1Data = ref();
const imageBgEditRef = ref(null);
const selectSize = ref(0)
const list = ref([
  { key: 0, content: t('Original'), params: null },
  { key: 1, content: t('enhance-Custom'), params: null },
  { key: 2, content: '600*600px', params: '2*2 Inches' },
  { key: 3, content: '709*945px', params: '30*40mm' },
  { key: 4, content: '826*1062px', params: '35*45mm ' },
])
const fileModel = ref(null);
const orgWidth = ref('');
const orgHeight = ref('');
const indexImages = ref(0);
const num1 = ref(100)
const num2 = ref(100)
const BSize = ref(255)
const RSize = ref(255)
const GSize = ref(255)
const imgSize = ref('')
const count = ref(0)
function onEvaluate() {
  const fileList = [...props.fileList];
  fileList[0].isEvaluate = true;
  updateFileListEvent(fileList)
}
async function onApply() {
  if (isLogin.value) {
    let aiType = [82];
    if (props.applyEnabled && !imgGeneratorList.value[indexImages.value]?.enhanceUrl) {
    } else {
      return;
    }
    if (count.value !== 0) {
      return
    }
    count.value++
    if (imageBgEditRef.value) {
      const file = await imageBgEditRef.value.handleExport();
      if (!file) {
        count.value = 0;
        return;
      }
      useLogEvent({ eventName: "apply-id_photo_maker" });
      updateFileListEvent([
        {
          ...step1Data.value,
          status: uploadStatus.none,
          originUrl: "",
          enhanceUrl: '',
          imgList: [],
          file,
        },
      ]);
    }
    if (selectSize.value == 1) {
      imgSize.value = `${num1.value},${num2.value}`
    }
    applyEvent({
      enhanceCfgIds: aiType,
      color: `${BSize.value},${GSize.value},${RSize.value}`,
      size: imgSize.value,
    })
    count.value = 0;
  } else {
    mainStore.setVisibleLogin(true);
  }
}
watch(() => step.value, () => {
  if (step === StepStatus.success) {
    getColor()
  }
})

watch(
  () => props.fileList,
  () => {
    const fileList = props.fileList;
    if (fileList.length) {
      if (step.value === StepStatus.none) {
        if (fileList[0].status === uploadStatus.uploadFail) {
          messageBox.error(t("enhance-upload-fail"), null);
          cleanFile();
        } else if (fileList[0].status === uploadStatus.fail) {
          messageBox.error(t("enhance-catch"), null);
          cleanFile();
        } else if (fileList[0].status === uploadStatus.lodingImg) {
          // 清除下载
          cleanMenuDownload();
        } else if (fileList[0].status === uploadStatus.handle) {
          step1Data.value = fileList[0];
        } else if (fileList[0].status === uploadStatus.success) {
          step1Data.value = fileList[0];
          step.value = StepStatus.edit;
          orgWidth.value = fileList[0].width;
          orgHeight.value = fileList[0].height;
          onSize(selectSize.value)
          nextTick(() => {
            getColor()
          })
        }
      } else if (step.value === StepStatus.edit) {
        fileModel.value = fileList[0];
        if (fileList[0].imgList?.length) {
          // fileModel.value = fileList[0];
          imgGeneratorList.value = fileList[0]?.imgList.map((v) => {
            return {
              status: uploadStatus.lodingImg,
              enhanceUrl: decryptUrl(v.enhanceUrl),
              preImage: fileList[0].preImage,
            };
          });
          step.value = StepStatus.success;
        } else if (fileList[0].status === uploadStatus.lodingImg && fileList[0].enhanceUrl) {
          // fileModel.value = fileList[0];
          imgGeneratorList.value = [
            {
              status: uploadStatus.success,
              enhanceUrl: fileList[0].enhanceUrl,
              preImage: fileList[0].preImage,
            },
          ];
          step.value = StepStatus.success;

        }
      }
    } else {
      fileModel.value = null;
    }
  },
  { deep: true }
);
const indexColor = ref('white')
const urlColor = ref('rgb(255,255,255)')
const colorImg = ref('')
function onShowColor(params) {
  if (!step1Data.value?.enhanceUrl) {
    return;
  }
  indexColor.value = params;
  if (params == 'all') {
    pickColorShow.value = true
  } else {
    pickColorShow.value = false
    if (indexColor.value == 'white') {
      BSize.value = 255;
      RSize.value = 255;
      GSize.value = 255;
      urlColor.value = 'rgb(255,255,255)'
    } else if (indexColor.value == 'blue') {
      urlColor.value = 'rgb(0,116,255)'
      BSize.value = 255;
      RSize.value = 0;
      GSize.value = 116;
    } else {
      urlColor.value = 'rgb(229, 87, 87)'
      BSize.value = 87;
      RSize.value = 229;
      GSize.value = 87;
    }
    if (step.value === StepStatus.success) {
      return
    }
    getColor()
  }
}

function onSize(key) {
  selectSize.value = key;
  if (key == 0) {
    imgSize.value = `${orgWidth.value},${orgHeight.value}`
  } else if (key == 1) {
    return;
  } else if (key == 2) {
    imgSize.value = '600,600'
  } else if (key == 3) {
    imgSize.value = '709,945'
  } else if (key == 4) {
    imgSize.value = '826,1062'
  }
}
function getColor() {
  const canvas = document.getElementById('myCanvas');
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = urlColor.value;
  ctx.fillRect(0, 0, 720, 720);
  colorImg.value = canvas.toDataURL('image/png');
}
onMounted(() => {
  const images = [...uploadStore.images];
  if (images.length) {
    initData();
  }
  window.addEventListener(
    customEventNames.uploadLocalFilesSuccessEvent,
    uploadLocalFilesSuccess
  );
  window.addEventListener(
    customEventNames.taskFailRetryEvent,
    taskFailRetryEvent
  );

});
function initData() {
  cleanMenuDownload();
  imgGeneratorList.value = [];
  step.value = StepStatus.none;
  indexImages.value = 0;
  step1Data.value = null;
  step1();
}
onUnmounted(() => {
  window.removeEventListener(
    customEventNames.uploadLocalFilesSuccessEvent,
    uploadLocalFilesSuccess
  );
  window.removeEventListener(
    customEventNames.taskFailRetryEvent,
    taskFailRetryEvent
  );
  cleanMenuDownload();
  uploadStore.setImages([]);
});
function step1() {
  if (!isLogin.value) {
    mainStore.setVisibleLogin(true);
    cleanFile();
    return;
  }
  const timer = setInterval(() => {
    // 加载成功后进行处理,抠图
    if (props.fileList.length && props.fileList[0].status === uploadStatus.none) {
      clearInterval(timer);
      applyEvent({ enhanceCfgIds: [74] });
    } else if (props.fileList.length && props.fileList[0].status === uploadStatus.imageLoadFail) {
      clearInterval(timer);
      cleanFile();
      messageBox.error("load failed!", null);
    }
  }, 200);
}
function taskFailRetryEvent(e) {
  // 如果任务失败，重置数据
  setTimeout(() => {
    updateFileListEvent([{ ...e.detail, status: uploadStatus.uploadSuccess }]);
  }, 100);
}
function uploadLocalFilesSuccess(params) {
  initData();
}
function cleanFile() {
  updateFileListEvent([]);
  step.value = StepStatus.none;
  step1Data.value = null;
}
function onBgLoad() {
  updateFileListEvent([
    {
      status: uploadStatus.success,
      originUrl: step1Data.enhanceUrl,
    },
  ]);
}
function decryptUrl(url) {
  let enhanceUrl = "";
  if (url) {
    $encryptor?.setPrivateKey(privateKey);
    let part1 = url.substring(0, url.length / 2);
    let part2 = url.substring(url.length / 2);
    const dec1 = $encryptor?.decrypt(part1);
    const dec2 = $encryptor?.decrypt(part2);
    enhanceUrl = dec1 + dec2;
  }
  return enhanceUrl;
}
function onLoad() {
  console.log("抠图加载成功");
  updateFileListEvent([
    {
      ...props.fileList[0],
      status: uploadStatus.success,
      // originUrl: step1Data.value.enhanceUrl,
      // enhanceUrl: step1Data.value.enhanceUrl,
    },
  ]);
}
const urlColors = ref('')
function confirm(params, B, R, G) {
  urlColor.value = params;
  urlColors.value = params;
  BSize.value = B;
  RSize.value = R;
  GSize.value = G;
  pickColorShow.value = false
  if (step.value === StepStatus.success) {
    return
  }
  getColor();
}
function cancel(params) {
  pickColorShow.value = false
}
</script>
<style scoped>
.h-screen-minus-80 {
  height: calc(100vh - 80px);
}
</style>
